export default "/images/ic-alert.svg?2cb704625ed0be8af0a46f5e0ec13a2f";